/** API helpers pra /v1/users (admin only). */
import { api } from "@/lib/api";
import type { Page } from "@/lib/api-cadastros";
import type { AuthUser, UserRole } from "@/stores/auth";

export interface UserListItem {
  id: string;
  email: string;
  name: string | null;
  picture_url: string | null;
  role: UserRole;
  provider: string;
  is_active: boolean;
  is_blocked: boolean;
  onboarding_completed: boolean;
  last_login_at: string | null;
  login_count: number;
  created_at: string;
}

export interface ImpersonateResponse {
  target: UserListItem;
  tokens: {
    access_token: string;
    refresh_token: string;
    token_type: string;
    expires_in: number;
  };
}

export const usersApi = {
  list: async (params: Record<string, unknown> = {}): Promise<Page<UserListItem>> => {
    const { data } = await api.get<Page<UserListItem>>("/v1/users", { params });
    return data;
  },
  get: async (id: string): Promise<UserListItem> => {
    const { data } = await api.get<UserListItem>(`/v1/users/${id}`);
    return data;
  },
  updateRole: async (id: string, role: UserRole): Promise<UserListItem> => {
    const { data } = await api.patch<UserListItem>(`/v1/users/${id}/role`, { role });
    return data;
  },
  updateBlock: async (id: string, is_blocked: boolean): Promise<UserListItem> => {
    const { data } = await api.patch<UserListItem>(`/v1/users/${id}/block`, { is_blocked });
    return data;
  },
  impersonate: async (id: string): Promise<ImpersonateResponse> => {
    const { data } = await api.post<ImpersonateResponse>(`/v1/users/${id}/impersonate`);
    return data;
  },
};

/** Converte UserListItem → AuthUser (compat com store). */
export function toAuthUser(u: UserListItem): AuthUser {
  return {
    id: u.id,
    email: u.email,
    email_verified: true,
    name: u.name,
    picture_url: u.picture_url,
    role: u.role,
    provider: u.provider,
    is_active: u.is_active,
    is_blocked: u.is_blocked,
    onboarding_completed: u.onboarding_completed,
    last_login_at: u.last_login_at,
    created_at: u.created_at,
  };
}
